/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import FullButton from '../buttons/Full';
import Borders from './Borders';
import Image from './Image';
import Label from './Label';
import ArrowSmall from '../icons/ArrowSmall';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/event-card.scss';

const propTypes = {
    id: PropTypes.number,
    published: PropTypes.bool,
    title: PropTypes.string,
    description: PropTypes.string,
    date: PropTypes.string,
    dateStart: PropTypes.string,
    dateEnd: PropTypes.string,
    url: PropTypes.string,
    poster: AppPropTypes.image,
    posterCredits: PropTypes.string,
    tickets: PropTypes.bool,
    ticketsStatus: PropTypes.string,
    ticketsLink: PropTypes.string,
    format: PropTypes.string,
    borders: AppPropTypes.borders,
    withLink: PropTypes.bool,
    withPatch: PropTypes.bool,
    className: PropTypes.string,
    linkClassName: PropTypes.string,
};

const defaultProps = {
    id: null,
    published: true,
    title: null,
    description: null,
    date: null,
    dateStart: null,
    dateEnd: null,
    url: null,
    poster: {},
    posterCredits: null,
    tickets: false,
    ticketsStatus: 'available',
    ticketsLink: null,
    format: null,
    borders: {
        top: true,
        left: true,
        bottom: true,
        right: true,
    },
    withLink: true,
    withPatch: false,
    className: null,
    linkClassName: null,
};

const EventCard = ({
    id,
    published,
    title,
    description,
    date,
    dateStart,
    dateEnd,
    url,
    poster,
    posterCredits,
    tickets,
    ticketsStatus,
    ticketsLink,
    format,
    borders,
    withLink,
    withPatch,
    className,
    linkClassName,
}) => {
    if (id === null) {
        return null;
    }
    const inner = (
        <>
            <div className={styles.info}>
                <h3 className={styles.title}>{title}</h3>
                <p className={styles.dates}>
                    <span className={styles.dateStart}>{dateStart ? `${dateStart}` : null}</span>
                    <span className={styles.dateEnd}>
                        {dateEnd ? <ArrowSmall className={styles.arrow} /> : null}
                        {dateEnd ? <span className={styles.end}>{`${dateEnd}`}</span> : null}
                    </span>
                </p>
                {published === false ? (
                    <p className={styles.publication}>
                        <Label>{{ id: 'content.unpublished' }}</Label>
                    </p>
                ) : null}
                <p className={styles.description}>{description}</p>
            </div>
            <Image
                className={format !== 'page' ? styles.image : null}
                {...poster}
                src={poster ? poster.sizes.large : null}
                withPatch={withPatch}
                credits={posterCredits}
            />
        </>
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.unpublished]: published === false,
                    [styles[format]]: format !== null,
                    [className]: className !== null,
                },
            ])}
        >
            <Borders seed={date || id} borders={borders} hidden={format === 'page'}>
                <div className={styles.inner}>
                    {withLink ? (
                        <Link
                            className={classNames([
                                styles.link,
                                {
                                    [linkClassName]: linkClassName !== null,
                                },
                            ])}
                            to={url}
                        >
                            {inner}
                        </Link>
                    ) : (
                        inner
                    )}
                    {format === 'small' || !tickets ? null : (
                        <FullButton
                            className={styles.button}
                            centered
                            highlighted
                            disabled={!tickets}
                            href={tickets && ticketsLink ? ticketsLink : null}
                        >
                            {ticketsStatus}
                        </FullButton>
                    )}
                </div>
            </Borders>
        </div>
    );
};

EventCard.propTypes = propTypes;
EventCard.defaultProps = defaultProps;

export default EventCard;
